import $ from 'jquery'
import { SfLog } from '@app/adapters/logger'
import { toDependencyGraph } from '@app/application/reconciliation/dependency-tree'

// Pixels between depth levels (x) and between sibling rows (y), plus canvas
// padding around the laid-out graph.
const X_STEP = 220
const Y_STEP = 70
const PADDING = 48
const MIN_HEIGHT = 240

onDomLoad(function ($dom) {
  $dom.on('click', '.dependents-tree-wrapper', function () {
    const container = this.querySelector("[data-behaviour='dependencies-tree']")
    if (!container || container.dataset.rendered) return

    // Mark as rendered up front so the in-flight request can't be fired twice
    // by repeated toggles of the <details> wrapper.
    container.dataset.rendered = 'true'

    Silverfin.Spinner.start()
    $.ajax({
      url: container.dataset.url,
      dataType: 'json',
      success: (treeData) => {
        renderDependenciesGraph(container, treeData)
          .catch((error) => {
            container.dataset.rendered = ''
            SfLog.error('Failed to render dependencies graph:', { error })
          })
          .finally(() => Silverfin.Spinner.success())
      },
      error: (_jqXHR, _status, error) => {
        container.dataset.rendered = ''
        SfLog.error('Failed to load dependencies graph:', { error })
        Silverfin.Spinner.failed()
      },
    })
  })
})

async function renderDependenciesGraph(container, treeData) {
  if (!Array.isArray(treeData) || !treeData[0]) return

  const { nodes, links } = toDependencyGraph(treeData[0])

  // Scale the abstract coordinates to pixels, normalised so the top-left of the
  // graph sits at PADDING.
  let minX = Infinity
  let minY = Infinity
  let maxY = -Infinity
  for (const node of nodes) {
    if (node.x < minX) minX = node.x
    if (node.y < minY) minY = node.y
    if (node.y > maxY) maxY = node.y
  }

  const data = nodes.map((node) => ({
    id: node.id,
    name: node.name,
    tooltip: node.tooltip,
    x: (node.x - minX) * X_STEP + PADDING,
    y: (node.y - minY) * Y_STEP + PADDING,
    label: { position: node.labelPosition },
  }))

  const height = (maxY - minY) * Y_STEP + PADDING * 2
  container.style.height = `${Math.max(height, MIN_HEIGHT)}px`

  const [{ echarts }, { observeEchartsResize }] = await Promise.all([
    import(/* webpackChunkName: "echarts" */ '@app/shared/echarts'),
    import('@app/shared/echarts/observe-echarts-resize'),
  ])
  const chart = echarts.init(container)
  observeEchartsResize(chart, container)

  chart.setOption({
    tooltip: {
      trigger: 'item',
      formatter: (params) =>
        params.dataType === 'edge' ? '' : params.data.tooltip ?? params.name,
    },
    series: [
      {
        type: 'graph',
        layout: 'none',
        // Trees can be large; allow pan/zoom since there's no collapse/expand.
        roam: true,
        symbolSize: 12,
        edgeSymbol: ['none', 'arrow'],
        edgeSymbolSize: 9,
        itemStyle: { color: '#fff', borderColor: 'steelblue', borderWidth: 2 },
        lineStyle: { color: '#ccc', width: 1.5 },
        label: { show: true, fontSize: 12, color: '#333' },
        emphasis: { focus: 'adjacency' },
        data,
        links,
      },
    ],
  })
}
